import { render, staticRenderFns } from "./dealCopyRequest.vue?vue&type=template&id=b506366c&"
import script from "./dealCopyRequest.vue?vue&type=script&lang=ts&"
export * from "./dealCopyRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports